export const initialState = {
  values: {
    agriBusinessDetailId:"",
    agriBusinessName: "",
    agriBusinessPoc: "",
    agriBusinessWebsite: "http://localhost.com",
    agriBusinessPocContact: '',
    agriBusinessPocEmail: '',
    country: '',
    state: '',
    cityId: '',
    otherAreas: '',
    idCard1: '',
    idCard2: '',
    passport: '',
    showPassword: false,
  },
  errors: {
    agriBusinessName: "",
    agriBusinessPoc: "",
    agriBusinessWebsite: "",
    agriBusinessPocContact: '',
    agriBusinessPocEmail: '',
    country: '',
    state: '',
    cityId: '',
    otherAreas: '',
  },
}
